// 导入绘画引擎
import {Topology, Node, Rect} from '@topology/core'
import {registerFlvPlayer, registerIFrame, registerScrollList} from '@/components/topologyDiagram'
import {debounce} from '@/utils/public'

export default {
  name: 'TopologyMap',
  data () {
    return {
      loading: false,
      showNoData: false, // 显示无数据提示
      canvas: null,
      viewClientWidth: 0, // 视图客户区宽度
      viewClientHeight: 0, // 视图客户区高度
      viewScrollWidth: 0, // 视图滚动宽度（图像缩放后宽度，最小为视图客户区宽度）
      viewScrollHeight: 0, // 视图滚动高度（图像缩放后高度，最小为视图客户区高度）
      mapWidth: 0, // 地图宽度（图像原始宽度）
      mapHeight: 0, // 地图高度（图像原始高度）
      mapViewWidthRatio: 1, // 地图视图宽度比
      mapViewHeightRatio: 1, // 地图视图高度比
      currentMap: null,
      currentMapId: 0,
      currentMapNode: null,
      mapNodes: [],
      animatedMapNodes: [],
      animationUpdateRequired: false
    }
  },
  props: {
    canvasOptions: {
      type: Object,
      default() {
        return {
          rotateCursor: '',
          activeColor: 'red', // 选中层颜色
          hoverColor: 'green', // 活动层颜色
          hideInput: true, // 是否禁止双击节点文字，出现文字输入框
          hideRotateCP: true, // 是否隐藏节点旋转控制点
          hideSizeCP: true, // 是否隐藏节点大小控制点
          disableEmptyLine: true, // 是否禁止连线终点为空（未连接到节点）
          locked: 1 // 0-None，未锁定，可任意编辑；1-Readonly，只读模式，允许选中；2-NoMove，不能移动，10-NoEvent，禁止鼠标交互，无法做任何操作，纯静态画面模式
        }
      }
    },
    maps: {
      type: Array,
      default() {
        return []
      }
    },
    mapNodeModels: {
      type: Array,
      default() {
        return []
      }
    },
    mapReadyLoad: {
      type: Function
    },
    mapLoad: {
      type: Function
    },
    mapReadyUnload: {
      type: Function
    },
    mapUnload: {
      type: Function
    },
    nodeClick: {
      type: Function
    }
  },
  mounted() {
    registerFlvPlayer()
    registerIFrame()
    registerScrollList()
  },
  beforeDestroy() {
    this.unloadMap()
  },
  methods: {
    // 加载地图
    loadMap(map) {
      if (!map || map.id === this.currentMapId) {
        return
      }

      this.unloadMap()
      this.loading = true
      this.showNoData = false
      if (this.mapReadyLoad) {
        this.mapReadyLoad(map)
      }
      this.currentMap = map
      this.currentMapId = map.id

      let canvasOptions2 = this.canvasOptions
      canvasOptions2.on = this.handleMapMessage
      canvasOptions2.disableScale = false
      if (canvasOptions2.locked === 0) { // 编辑状态
      } else {
        if (this.currentMap.lockType === 0) { // 未锁定
        } else if (this.currentMap.lockType === 1) { // 不能移动缩放
          canvasOptions2.disableScale = true
        } else if (this.currentMap.lockType === 2) { // 禁止鼠标事件
          canvasOptions2.disableScale = true
        }
      }
      this.canvas = new Topology('topology-map', canvasOptions2)
      this.canvas.clearBkImg()
      this.canvas.data.bkImageRect = new Rect(
        0, 0, this.canvas.canvas.canvas.scrollWidth, this.canvas.canvas.canvas.scrollHeight
      )
      this.canvas.data.bkImage = this.currentMap.imageUrl // 加载背景图片
      if (canvasOptions2.locked === 0) { // 编辑状态
        this.canvas.data.locked = 0
      } else {
        if (this.currentMap.lockType === 0) { // 未锁定
          this.canvas.data.locked = 1
        } else if (this.currentMap.lockType === 1) { // 不能移动缩放
          this.canvas.data.locked = 2
        } else if (this.currentMap.lockType === 2) { // 禁止鼠标事件
          this.canvas.data.locked = 10
        }
      }
      this.canvas.render()

      this.viewClientWidth = this.canvas.canvas.canvas.clientWidth
      this.viewClientHeight = this.canvas.canvas.canvas.clientHeight
      this.viewScrollWidth = this.canvas.canvas.canvas.scrollWidth
      this.viewScrollHeight = this.canvas.canvas.canvas.scrollHeight
      this.mapWidth = map.imageWidth
      this.mapHeight = map.imageHeight
      // 计算地图视图长宽比
      this.mapViewWidthRatio = this.viewScrollWidth / this.mapWidth
      this.mapViewHeightRatio = this.viewScrollHeight / this.mapHeight

      console.log('map resize: scale:' + this.canvas.data.scale + ',sizeRatio:(' + this.mapViewWidthRatio + ',' + this.mapViewHeightRatio + '),mapWidth: ' +
        this.mapWidth + ',mapHeight: ' + this.mapHeight + ',zoomedMapWidth: ' +
        this.viewScrollWidth + ',zoomedMapHeight: ' + this.viewScrollHeight)

      if (this.mapLoad) {
        this.mapLoad(map)
      }
      this.loading = false
    },
    // 加载顶层地图
    loadRootMap() {
      let map = this.$globalData.maps.find(item => {
        return item.parentMapId === 0
      })
      if (map) {
        this.loadMap(map)
      }
    },
    // 根据指定地图id加载地图
    loadMapByMapId(mapId) {
      let map = this.$globalData.maps.find(item => {
        return item.id === mapId
      })
      if (!map) {
        this.unloadMap()
        return
      }

      if (map.id !== this.currentMapId) {
        this.loadMap(map)
      }
    },
    // 根据指定区域id加载地图
    loadMapByRegionId(regionId, systemKind) {
      let map = null
      if (systemKind === 0) { // 系统种类不限制
        map = this.$globalData.maps.find(item => {
          return item.mapRegionId === regionId
        })
      } else { // 系统种类已指定
        map = this.$globalData.maps.find(item => { // 优先返回完全匹配的map
          return item.mapRegionId === regionId && item.systemKindSet && item.systemKindSet.indexOf(systemKind.toString()) > -1
        })
        // if (!map) { // 其次返回仅匹配区域id的map
        //   map = this.$globalData.maps.find(item => {
        //     return item.mapRegionId === regionId && (!item.systemKindSet || item.systemKindSet === '0')
        //   })
        // }
      }

      if (!map) {
        this.unloadMap()
        return
      }

      if (map.id !== this.currentMapId) {
        this.loadMap(map)
      }
    },
    // 卸载地图
    unloadMap() {
      if (this.currentMap) {
        if (this.mapReadyUnload) {
          this.mapReadyUnload(this.currentMap)
        }
        this.unloadMapNodeList()
        this.canvas.clearBkImg()
        this.canvas.data.bkImage = ''
        this.canvas.render()
        this.canvas = null
        this.currentMap = null
        this.currentMapId = 0
        if (this.mapUnload) {
          this.mapUnload()
        }
      }
      this.showNoData = true
    },
    // 切换地图
    switchMap(map) {
      this.loadMap(map)
    },
    // 刷新地图
    refreshMap() {
      if (!this.currentMap) {
        return
      }
      this.canvas.render()
      // 通知画布刷新动画绘画(animate方法应避免频繁调用，否则最后一次可能不生效)
      if (this.animationUpdateRequired) {
        this.canvas.animate()
        this.animationUpdateRequired = false
      }
    },
    // 锁定地图
    lockMap(lockType) {
      if (!this.currentMap || !this.canvas) {
        return
      }
      this.canvas.lock(lockType)
    },
    // 加载地图节点列表
    loadMapNodeList(mapNodes) {
      if (!this.currentMap || mapNodes.length === 0) {
        return
      }

      this.mapNodes = mapNodes
      this.mapNodes.forEach(item => {
        let nodeName = 'image'
        if (item.modelKind === 0) { // 图片
          nodeName = 'image'
        } else if (item.modelKind === 8) { // 文本
          nodeName = 'text'
        } else if (item.modelKind === 5) { // 视频
          nodeName = 'FlvPlayer'
        } else if (item.modelKind === 4000) { // iframe
          nodeName = 'IFrame'
        } else if (item.modelKind === 2005) { // 无缝滚动
          nodeName = 'ScrollList'
        } else {
        }
        let node = this.createTpNode(nodeName, item)
        if (node) {
          this.canvas.data.pens.push(node)
        }
      })
      this.canvas.render()
      // 通知画布刷新动画绘画(animate方法应避免频繁调用，否则最后一次可能不生效)
      if (this.animationUpdateRequired) {
        this.canvas.animate()
        this.animationUpdateRequired = false
      }
    },
    // 卸载地图节点列表
    unloadMapNodeList() {
      if (!this.currentMap || this.mapNodes.length === 0 || this.canvas.data.pens.length === 0) {
        return
      }

      this.stopAllNodeAnimations()

      // 检测是否关联处理节点销毁函数（!!!私有扩展）
      this.canvas.data.pens.forEach(item => {
        if (item.extOnDestroy) {
          item.extOnDestroy(item)
          item.extOnDestroy = undefined
        }
      })
      this.canvas.data.pens = []
      this.canvas.render()
      this.mapNodes = []
    },
    // 创建TP节点
    createTpNode(name, mapNode) {
      let nodeWidth = mapNode.imageWidth === 0 ? 16 : mapNode.imageWidth
      let nodeHeight = mapNode.imageHeight === 0 ? 16 : mapNode.imageHeight
      let nodeFontSize = mapNode.fontSize > 0 ? Math.ceil(mapNode.fontSize * 4 / 3) : 14
      let nodeText = ''
      let maxTextWidth = 0
      let hasImage = true
      if (mapNode.modelKind === 0) { // 图片
      } else if (mapNode.modelKind === 8) { // 文本
        nodeHeight = 0
        hasImage = false
        if (!mapNode.objectNameVisible && !mapNode.objectValueVisible) {
          mapNode.resource ? mapNode.objectValueVisible = true : mapNode.objectNameVisible = true
        }
      } else if (mapNode.modelKind === 5) { // 视频
      } else if (mapNode.modelKind === 4000) { // iframe
      } else if (mapNode.modelKind === 2005) { // 无缝滚动
      } else {
      }

      // 组合名称和数值文本，计算节点实际宽度和高度
      if (mapNode.objectNameVisible || mapNode.objectValueVisible) {
        if (mapNode.objectNameVisible) { // 显示名称
          maxTextWidth = this.getTextWidth(mapNode.fontFamily, nodeFontSize, mapNode.name)
          if (hasImage) {
            nodeHeight += 5 // 图像与文本垂直方向间距
          }
          nodeHeight += this.getTextHeight(mapNode.fontFamily, nodeFontSize)
          nodeText = mapNode.name
          if (mapNode.objectValueVisible && mapNode.valueText) { // 显示数值
            let mapNodeValueText = '\n' + mapNode.valueText
            let maxTextWidth2 = this.getTextWidth(mapNode.fontFamily, nodeFontSize, mapNodeValueText)
            maxTextWidth = maxTextWidth2 > maxTextWidth ? maxTextWidth2 : maxTextWidth
            nodeHeight += 5 // 文本与文本垂直方向间距
            nodeHeight += this.getTextHeight(mapNode.fontFamily, nodeFontSize)
            nodeText += mapNodeValueText
          }
        } else { // 仅显示数值
          if (mapNode.objectValueVisible && mapNode.valueText) {
            maxTextWidth = this.getTextWidth(mapNode.fontFamily, nodeFontSize, mapNode.valueText)
            if (hasImage) {
              nodeHeight += 5 // 图像与文本垂直方向间距
            }
            nodeHeight += this.getTextHeight(mapNode.fontFamily, nodeFontSize)
            nodeText = mapNode.valueText
          }
        }
        nodeWidth = nodeWidth <= maxTextWidth ? maxTextWidth : nodeWidth
        nodeWidth += 8 // 左右各设置4像素边距
      }
      nodeHeight = nodeHeight === 0 ? mapNode.imageHeight === 0 ? nodeFontSize : mapNode.imageHeight : nodeHeight

      // 根据资源状态返回图片url和文本颜色
      let imageUrl = mapNode.imageUrl
      let fontColor = mapNode.fontColor ? '#' + mapNode.fontColor : '#000000'
      let animationRequired = false
      if (mapNode.resource) {
        if (mapNode.resourceKind === 22 || // 模拟量输入
          mapNode.resourceKind === 23) { // 信号量输入
          let workState = this.$type.getResourceWorkState(mapNode.resourceKind, mapNode.resource.gaugedObjectKind, mapNode.resource.guagedValue,
            mapNode.resource.realValue, mapNode.resource.scaleFactor, mapNode.resource.correctedValue, mapNode.resource.valueType, mapNode.resource.decimalDigit)
          if (mapNode.resource.alarmState === 0) { // 正常状态
            // 打开状态或运行状态
            if (mapNode.resourceKind === 22) { // 信号量输入
              imageUrl = Math.round(workState) === 1 ? mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl : mapNode.imageUrl
              fontColor = Math.round(workState) === 1 ? '#F59523' : fontColor
              animationRequired = Math.round(workState) === 1
            }
          } else if (mapNode.resource.alarmState === 1) { // 告警状态
            imageUrl = mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl
            fontColor = '#EC5746'
            animationRequired = true
          } else if (mapNode.resource.alarmState === 2) { // 未知状态
            imageUrl = mapNode.imageUrl3 ? mapNode.imageUrl3 : mapNode.imageUrl
            fontColor = '#666666'
          }
        } else if (mapNode.resourceKind === 24 || // 信号量输出
          mapNode.resourceKind === 25) { // 模拟量输出
          let controlState = this.$type.getResourceControlState(mapNode.resourceKind, mapNode.resource.controlValue, mapNode.resource.valueType)
          if (mapNode.resourceKind === 24) { // 信号量输出
            imageUrl = Math.round(controlState) === 1 ? mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl : mapNode.imageUrl
            fontColor = Math.round(controlState) === 1 ? '#F59523' : fontColor
            animationRequired = Math.round(controlState) === 1
          }
        } else if (mapNode.resourceKind === 29) { // 地图
          if (mapNode.resource.alarmCount && mapNode.resource.alarmCount > 0) { // 映射区域告警状态
            imageUrl = mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl
          } else if (typeof (mapNode.resource.isOnline) !== 'undefined') { // 映射区域在线状态
            imageUrl = mapNode.resource.isOnline ? mapNode.imageUrl : mapNode.imageUrl3 ? mapNode.imageUrl3 : mapNode.imageUrl
          }
        } else if (mapNode.resourceKind === 71) { // 地图动作
        }
      } else {
        if (mapNode.resourceKind === 0 || // 监控设备
          mapNode.resourceKind === 21 || // 视频节点
          mapNode.resourceKind === 22 || // 信号量输入
          mapNode.resourceKind === 23 || // 模拟量输入
          mapNode.resourceKind === 24 || // 信号量输出
          mapNode.resourceKind === 25 || // 模拟量输出
          mapNode.resourceKind === 26 || // 语音节点
          mapNode.resourceKind === 29 || // 地图
          mapNode.resourceKind === 31 || // 定位节点
          mapNode.resourceKind === 51 || // 事件集合
          mapNode.resourceKind === 71 || // 地图动作
          mapNode.resourceKind === 150) { // 区域
          return null
        }
      }

      // 获取节点数据和配置
      let nodeData = mapNode.resource ? mapNode.resource : {}
      let nodeOption = mapNode.expandInfo.length ? JSON.parse(mapNode.expandInfo) : {}

      // 创建节点
      let tpNode = new Node({
        text: nodeText,
        rect: {
          x: mapNode.xScale * this.viewScrollWidth,
          y: mapNode.yScale * this.viewScrollHeight,
          width: nodeWidth * (mapNode.transformationEnabled ? this.mapViewWidthRatio : 1),
          height: nodeHeight * (mapNode.transformationEnabled ? this.mapViewHeightRatio : 1)
        },
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        borderRadius: 0.1,
        image: imageUrl,
        imageWidth: hasImage ? mapNode.imageWidth * (mapNode.transformationEnabled ? this.mapViewWidthRatio : 1) : 0,
        imageHeight: hasImage ? mapNode.imageHeight * (mapNode.transformationEnabled ? this.mapViewHeightRatio : 1) : 0,
        fontColor: fontColor,
        fontFamily: mapNode.fontFamily ? mapNode.fontFamily : '微软雅黑',
        fontSize: nodeFontSize,
        fontWeight: mapNode.fontBold ? 'bold' : 'normal',
        name: name,
        data: {mapNode: mapNode, data: nodeData, option: nodeOption}
      })
      tpNode.title = mapNode.name // tooltip

      // 启动动效
      if (animationRequired) {
        this.startNodeAnimation(mapNode, tpNode)
      } else {
      }
      return tpNode
    },
    // 更新TP节点
    updateTpNode(mapNode) {
      let tpNode = this.canvas.data.pens.find(item => {
        return item.data && item.data.mapNode && mapNode.id === item.data.mapNode.id
      })
      if (!tpNode) {
        return false
      }

      let nodeWidth = mapNode.imageWidth === 0 ? 16 : mapNode.imageWidth
      let nodeHeight = mapNode.imageHeight === 0 ? 16 : mapNode.imageHeight
      let nodeFontSize = mapNode.fontSize > 0 ? Math.ceil(mapNode.fontSize * 4 / 3) : 14
      let nodeText = ''
      let maxTextWidth = 0
      let hasImage = true
      if (mapNode.modelKind === 0) { // 图片
      } else if (mapNode.modelKind === 8) { // 文本
        nodeHeight = 0
        hasImage = false
        if (!mapNode.objectNameVisible && !mapNode.objectValueVisible) {
          mapNode.resource ? mapNode.objectValueVisible = true : mapNode.objectNameVisible = true
        }
      } else if (mapNode.modelKind === 5) { // 视频
      } else if (mapNode.modelKind === 4000) { // iframe
      } else if (mapNode.modelKind === 2005) { // 无缝滚动
      } else {
      }

      // 组合名称和数值文本，计算节点实际宽度和高度
      if (mapNode.objectNameVisible || mapNode.objectValueVisible) {
        if (mapNode.objectNameVisible) { // 显示名称
          maxTextWidth = this.getTextWidth(mapNode.fontFamily, nodeFontSize, mapNode.name)
          if (hasImage) {
            nodeHeight += 5 // 图像与文本垂直方向间距
          }
          nodeHeight += this.getTextHeight(mapNode.fontFamily, nodeFontSize)
          nodeText = mapNode.name
          if (mapNode.objectValueVisible && mapNode.valueText) { // 显示数值
            let mapNodeValueText = '\n' + mapNode.valueText
            let maxTextWidth2 = this.getTextWidth(mapNode.fontFamily, nodeFontSize, mapNodeValueText)
            maxTextWidth = maxTextWidth2 > maxTextWidth ? maxTextWidth2 : maxTextWidth
            nodeHeight += 5 // 文本与文本垂直方向间距
            nodeHeight += this.getTextHeight(mapNode.fontFamily, nodeFontSize)
            nodeText += mapNodeValueText
          }
        } else { // 仅显示数值
          if (mapNode.objectValueVisible && mapNode.valueText) {
            maxTextWidth = this.getTextWidth(mapNode.fontFamily, nodeFontSize, mapNode.valueText)
            if (hasImage) {
              nodeHeight += 5 // 图像与文本垂直方向间距
            }
            nodeHeight += this.getTextHeight(mapNode.fontFamily, nodeFontSize)
            nodeText = mapNode.valueText
          }
        }
        nodeWidth = nodeWidth <= maxTextWidth ? maxTextWidth : nodeWidth
        nodeWidth += 8 // 左右各设置4像素边距
      }
      nodeHeight = nodeHeight === 0 ? mapNode.imageHeight === 0 ? nodeFontSize : mapNode.imageHeight : nodeHeight

      // 根据资源状态返回图片url和文本颜色
      let imageUrl = mapNode.imageUrl
      let fontColor = mapNode.fontColor ? '#' + mapNode.fontColor : '#000000'
      let animationRequired = false
      if (mapNode.resource) {
        if (mapNode.resourceKind === 22 || // 模拟量输入
          mapNode.resourceKind === 23) { // 信号量输入
          let workState = this.$type.getResourceWorkState(mapNode.resourceKind, mapNode.resource.gaugedObjectKind, mapNode.resource.guagedValue,
            mapNode.resource.realValue, mapNode.resource.scaleFactor, mapNode.resource.correctedValue, mapNode.resource.valueType, mapNode.resource.decimalDigit)
          if (mapNode.resource.alarmState === 0) { // 正常状态
            // 打开状态或运行状态
            if (mapNode.resourceKind === 22) { // 信号量输入
              imageUrl = Math.round(workState) === 1 ? mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl : mapNode.imageUrl
              fontColor = Math.round(workState) === 1 ? '#F59523' : fontColor
              animationRequired = Math.round(workState) === 1
            }
          } else if (mapNode.resource.alarmState === 1) { // 告警状态
            imageUrl = mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl
            fontColor = '#EC5746'
            animationRequired = true
          } else if (mapNode.resource.alarmState === 2) { // 未知状态
            imageUrl = mapNode.imageUrl3 ? mapNode.imageUrl3 : mapNode.imageUrl
            fontColor = '#666666'
          }
        } else if (mapNode.resourceKind === 24 || // 信号量输出
          mapNode.resourceKind === 25) { // 模拟量输出
          let controlState = this.$type.getResourceControlState(mapNode.resourceKind, mapNode.resource.controlValue, mapNode.resource.valueType)
          if (mapNode.resourceKind === 24) { // 信号量输出
            imageUrl = Math.round(controlState) === 1 ? mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl : mapNode.imageUrl
            fontColor = Math.round(controlState) === 1 ? '#F59523' : fontColor
            animationRequired = Math.round(controlState) === 1
          }
        } else if (mapNode.resourceKind === 29) { // 地图
          if (mapNode.resource.alarmCount && mapNode.resource.alarmCount > 0) { // 映射区域告警状态
            imageUrl = mapNode.imageUrl2 ? mapNode.imageUrl2 : mapNode.imageUrl
          } else if (typeof (mapNode.resource.isOnline) !== 'undefined') { // 映射区域在线状态
            imageUrl = mapNode.resource.isOnline ? mapNode.imageUrl : mapNode.imageUrl3 ? mapNode.imageUrl3 : mapNode.imageUrl
          }
        } else if (mapNode.resourceKind === 71) { // 地图动作
        }
      } else {
        if (mapNode.resourceKind === 0 || // 监控设备
          mapNode.resourceKind === 21 || // 视频节点
          mapNode.resourceKind === 22 || // 信号量输入
          mapNode.resourceKind === 23 || // 模拟量输入
          mapNode.resourceKind === 24 || // 信号量输出
          mapNode.resourceKind === 25 || // 模拟量输出
          mapNode.resourceKind === 26 || // 语音节点
          mapNode.resourceKind === 29 || // 地图
          mapNode.resourceKind === 31 || // 定位节点
          mapNode.resourceKind === 51 || // 事件集合
          mapNode.resourceKind === 71 || // 地图动作
          mapNode.resourceKind === 150) { // 区域
          return null
        }
      }

      // 获取节点数据和配置
      let nodeData = mapNode.resource ? mapNode.resource : {}
      let nodeOption = mapNode.expandInfo.length ? JSON.parse(mapNode.expandInfo) : {}

      //
      let zoomedNodeWidth = nodeWidth * (mapNode.transformationEnabled ? this.mapViewWidthRatio : 1)
      let zoomedNodeHeight = nodeHeight * (mapNode.transformationEnabled ? this.mapViewHeightRatio : 1)
      if (Math.round(tpNode.rect.x) !== Math.round(mapNode.xScale * this.viewScrollWidth) ||
        Math.round(tpNode.rect.y) !== Math.round(mapNode.yScale * this.viewScrollHeight) ||
        Math.round(tpNode.rect.width) !== Math.round(zoomedNodeWidth) ||
        Math.round(tpNode.rect.height) !== Math.round(zoomedNodeHeight)) {
        tpNode.rect = new Rect(mapNode.xScale * this.viewScrollWidth, mapNode.yScale * this.viewScrollHeight,
          zoomedNodeWidth, zoomedNodeHeight)
        tpNode.imageWidth = hasImage ? mapNode.imageWidth * (mapNode.transformationEnabled ? this.mapViewWidthRatio : 1) : 0
        tpNode.imageHeight = hasImage ? mapNode.imageHeight * (mapNode.transformationEnabled ? this.mapViewHeightRatio : 1) : 0
      }
      if (nodeText !== tpNode.text) { // tooltip
        tpNode.text = nodeText
        tpNode.title = mapNode.name
      }
      if (imageUrl !== tpNode.image) {
        tpNode.image = imageUrl
      }
      if (fontColor !== tpNode.fontColor) {
        tpNode.fontColor = fontColor
      }

      tpNode.data.data = nodeData
      tpNode.data.option = nodeOption

      this.canvas.updateProps(false, [tpNode])

      // 启动动效
      if (animationRequired) {
        this.startNodeAnimation(mapNode, tpNode)
      } else {
        this.stopNodeAnimation(mapNode, tpNode)
      }
      return true
    },
    // 更新全部节点
    updateAllNodes() {
      if (this.mapNodes.length === 0) {
        return
      }
      this.mapNodes.forEach(item => {
        this.updateTpNode(item)
      })

      this.canvas.render()
      // 通知画布刷新动画绘画(animate方法应避免频繁调用，否则最后一次可能不生效)
      if (this.animationUpdateRequired) {
        this.canvas.animate()
        this.animationUpdateRequired = false
      }
    },
    // 启动节点动画
    startNodeAnimation(mapNode, tpNode) {
      let index = this.animatedMapNodes.findIndex(item => {
        return item.id === mapNode.id
      })
      if (index >= 0) { // 已存在，直接返回
        return
      }

      if (tpNode == null) {
        tpNode = this.canvas.data.pens.find(item => {
          return item.data && item.data.mapNode && mapNode.id === item.data.mapNode.id
        })
        if (!tpNode) {
          return
        }
      }

      if (!mapNode.animationType || mapNode.animationType === 0) { // 未启用动效
        return
      }

      // 设置node.animateFrames
      // 复制当前节点状态
      const state = Node.cloneState(tpNode)
      switch (mapNode.animationType) {
        case 1: // 图像转动（imageRotation）
          state.rotate = 360
          tpNode.animateFrames.push({
            duration: 1000,
            linear: true,
            state
          })
          break
        case 20: // 上下（upDown）
          // 修改状态位置
          state.rect.y -= 10
          state.rect.ey -= 10
          tpNode.animateFrames.push({
            duration: 100,
            linear: true,
            state
          })
          // 回到初始状态
          tpNode.animateFrames.push({
            duration: 200,
            linear: true,
            state: Node.cloneState(tpNode)
          })
          break
        case 21: // 心跳（heart）
          state.rect.x -= 5
          state.rect.ex += 5
          state.rect.y -= 5
          state.rect.ey += 5
          state.rect.width += 5
          state.rect.height += 10
          tpNode.animateFrames.push({
            duration: 100,
            linear: true,
            state
          })
          // 回到初始状态
          tpNode.animateFrames.push({
            duration: 400,
            linear: true,
            state: Node.cloneState(tpNode)
          })
          break
        default:
          return
      }
      // 设置帧间隔
      tpNode.animateDuration = 0
      tpNode.animateFrames.forEach(item => {
        tpNode.animateDuration += item.duration
      })
      // 设置开始播放属性（为当前时间）
      tpNode.animateStart = Date.now()
      this.animatedMapNodes.push(mapNode)
      this.animationUpdateRequired = true
    },
    // 停止节点动画
    stopNodeAnimation(mapNode, tpNode) {
      if (!mapNode.animationType || mapNode.animationType === 0) { // 未启用动效
        return
      }

      let index = this.animatedMapNodes.findIndex(item => {
        return item.id === mapNode.id
      })
      if (index < 0) { // 不存在，直接返回
        return
      }

      if (tpNode == null) {
        tpNode = this.canvas.data.pens.find(item => {
          return item.data && item.data.mapNode && mapNode.id === item.data.mapNode.id
        })
        if (!tpNode) {
          return
        }
      }

      // 停止播放
      tpNode.animateStart = 0
      tpNode.animateDuration = 0
      tpNode.animateFrames = []
      this.animatedMapNodes.splice(index, 1)
      this.animationUpdateRequired = true
    },
    // 停止全部节点动画
    stopAllNodeAnimations() {
      if (this.animatedMapNodes.length === 0) {
        return
      }
      this.animatedMapNodes.forEach(item => {
        let tpNode = this.canvas.data.pens.find(item2 => {
          return item2.data && item2.data.mapNode && item.id === item2.data.mapNode.id
        })
        if (tpNode) {
          // 停止播放
          tpNode.animateStart = 0
          tpNode.animateDuration = 0
          tpNode.animateFrames = []
        }
      })
      this.animatedMapNodes = []
      // 通知画布刷新动画绘画(animate方法应避免频繁调用，否则最后一次可能不生效)
      this.canvas.animate()
      this.animationUpdateRequired = false
    },
    // 处理地图消息
    handleMapMessage(event, data) {
      // console.log(event, data)
      switch (event) {
        case 'resize':
          this.handleReszie(data)
          break // 单击节点
        case 'node':
          this.handleNodeClick(data)
          break // 单击节点
      }
    },
    // 处理尺寸改变
    handleReszie() {
      if (!this.canvas || !this.currentMap) {
        return
      }

      // 防抖(delay-延时，单位：毫秒）
      debounce(() => {
        this.viewWidth = this.canvas.canvas.canvas.clientWidth
        this.viewHeight = this.canvas.canvas.canvas.clientHeight
        this.viewScrollWidth = this.canvas.canvas.canvas.scrollWidth
        this.viewScrollHeight = this.canvas.canvas.canvas.scrollHeight

        // 计算地图视图长宽比
        this.mapViewWidthRatio = this.viewScrollWidth / this.mapWidth
        this.mapViewHeightRatio = this.viewScrollHeight / this.mapHeight

        this.canvas.clearBkImg()
        this.canvas.data.bkImageRect = new Rect(
          0, 0, this.canvas.canvas.canvas.scrollWidth, this.canvas.canvas.canvas.scrollHeight
        )
        this.canvas.data.bkImage = this.currentMap.imageUrl // 加载背景图片
        this.canvas.render()

        this.stopAllNodeAnimations()
        this.updateAllNodes()
        console.log('map resize: scale:' + this.canvas.data.scale + ',sizeRatio:(' + this.mapViewWidthRatio + ',' + this.mapViewHeightRatio + '),mapWidth: ' +
          this.mapWidth + ',mapHeight: ' + this.mapHeight + ',zoomedMapWidth: ' +
          this.viewScrollWidth + ',zoomedMapHeight: ' + this.viewScrollHeight)
      }, 500)
    },
    // 处理节点单击
    handleNodeClick(node) {
      this.currentMapNode = node.data.mapNode
      if (this.currentMapNode.resourceKind === 29) { // 地图
        let map = this.maps.find(item => {
          return item.id === this.currentMapNode.resourceId
        })
        this.switchMap(map)
      } else if (this.currentMapNode.resourceKind === 150) { // 区域
        let map2 = this.maps.find(item => {
          return item.mapRegionId === this.currentMapNode.resourceId
        })
        this.switchMap(map2)
      }
      if (this.nodeClick) {
        this.nodeClick(this.currentMapNode)
      }
    },
    // 返回文本宽度
    getTextWidth(fontFamily, fontSize, text) {
      if (!text) {
        return 0
      }

      let ctx = this.canvas.canvas.canvas.getContext('2d')
      if (ctx) {
        let oldFont = ctx.font
        // ctx.font = fontSize === 0 ? 12 : fontSize + 'px ' + fontFamily ? fontFamily : '微软雅黑'
        ctx.font = fontSize === 0 ? 14 : fontSize + 'px Microsoft YaHei'
        let textWidth = ctx.measureText(text).width
        ctx.font = oldFont
        return textWidth
      } else {
        return 0
      }
    },
    // 返回文本高度
    getTextHeight(fontFamily, fontSize) {
      return (fontSize === 0 ? 14 : fontSize) * 2
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/topologyMap/TopologyMap.js